<template>
  <div class="flex flex-col max-w-[800px] mx-auto gap-4">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="faq-item"
      :class="{ active: openIndex === i }"
      @click="toggle(i)"
    >
      <p class="title">{{ item.q }}</p>
      <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2 font-semibold leading-relaxed">
        {{ item.a }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{ items: { q: string; a: string }[] }>()

const openIndex = ref<number | null>(null)
function toggle(i: number) {
  openIndex.value = openIndex.value === i ? null : i
}
</script>

<style scoped>
@reference "@/assets/css/main.css";

.faq-item {
  @apply relative p-6 !pr-16 bg-white rounded-xl drop-shadow lg:min-w-[800px];
  cursor: pointer;

  .title {
    @apply text-lighter font-semibold;
  }

  .content {
    display: none;
  }

  &::after {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    content: '';
    width: 24px;
    height: 24px;
    background: url(/images/ico-plus.svg);
  }

  &.active {
    .title {
      @apply text-gradient-primary;
    }

    .content {
      display: block;
    }

    &::after {
      top: 1.4rem;
      background: url(/images/ico-min.svg);
    }
  }
}
</style>
